import apiFetch from '../apiFetch'

export default function (formState) {
  return apiFetch({ endPoint: 'login', method: 'POST', body: formState })
}
